import { render, staticRenderFns } from "./HeaderIconsDropdownCart.vue?vue&type=template&id=44443b88&scoped=true&"
import script from "./HeaderIconsDropdownCart.vue?vue&type=script&lang=js&"
export * from "./HeaderIconsDropdownCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44443b88",
  null
  
)

export default component.exports